import { Button } from '@heidi/design-system/button';
import { TypographyH4, TypographyP2 } from '@heidi/design-system/typography';
import { FormattedMessage } from 'react-intl';

export interface WorkspaceHydrationErrorProps {
  /** Re-runs the workspaces query and re-arms the hydration watchdog. */
  onRetry: () => void;
}

/**
 * The blocking panel `WorkspaceHydrationGate` renders when the cold-boot
 * workspace resolution ends degraded and the reason is not one of the two the
 * gate fails open on.
 *
 * It decides nothing. Which degraded reasons reach this panel is
 * `useWorkspaceHydrationStatus` (`@heidi/workspace/data`), and what retrying
 * means is the gate's: the panel takes the retry as a callback, so it
 * mounts under any provider tree with an `IntlProvider` above it.
 *
 * Extracted to @heidi/workspace — history:
 * `git log --follow packages/workspace/src/ui/workspace-hydration-gate/workspace-hydration-gate.tsx`.
 * The three message ids move VERBATIM, so no translation is re-minted.
 */
export const WorkspaceHydrationError = ({ onRetry }: WorkspaceHydrationErrorProps) => (
  <div className="flex h-dvh w-full flex-col items-center justify-center gap-2 p-6 text-center">
    <TypographyH4>
      <FormattedMessage
        defaultMessage="We couldn't load your workspace"
        id="IdC0ru9Mox"
      />
    </TypographyH4>
    <TypographyP2 className="text-text-secondary">
      <FormattedMessage
        defaultMessage="Check your connection and try again."
        id="xUnZ3uBJCE"
      />
    </TypographyP2>
    <Button size="lg" className="mt-2" onClick={onRetry}>
      <FormattedMessage defaultMessage="Try again" id="FazwRldA7z" />
    </Button>
  </div>
);
